<template>
  <v-container class="pa-0" fluid>
    <section v-if="loading_notifications" class="loader-container">
      <Loader text="Cargando notificaciones" />
    </section>

    <template v-else>
      <v-row
        no-gutters
        v-if="$vuetify.breakpoint.smAndDown"
        style="background: #eeeeee"
      >
        <v-col cols="12">
          <swipe-list
            ref="list"
            class="d-flex flex-column"
            style="gap: 1rem"
            :items="userNotifications"
            item-key="id"
          >
            <template v-slot="{ item }">
              <NotificationItem
                @show-notification="showNotification(item)"
                :notification="item"
              />
            </template>

            <template v-slot:right="{ item }">
              <div
                class="swipeout-action red"
                title="remove"
                @click="deleteNotification(item)"
                style="
                  width: 90px;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                "
              >
                <Loader small light v-if="deletingNotification" />
                <v-icon v-else color="white"> delete_outline </v-icon>
              </div>
            </template>
            <template v-slot:empty>
              <div>No existen notificaciones</div>
            </template>
          </swipe-list>
        </v-col>
      </v-row>

      <!-- VISTA DESKTOP  -->
      <v-row v-if="$vuetify.breakpoint.mdAndUp" no-gutters>
        <v-data-table
          :items="userNotifications"
          :headers="headersNotifications"
          hide-default-footer
          :items-per-page="-1"
          style="width: 100%"
          no-data-text="No existen notificaciones"
        >
          <template v-slot:item="{ item }">
            <tr :class="{ highlighted: !item.read }" style="cursor: pointer">
              <td style="padding-right: 0" @click="showNotification(item)">
                <div style="display: flex; justify-content: space-evenly">
                  <v-icon
                    v-if="!!item.request.is_urgency"
                    color="error"
                    class="mr-1"
                  >
                    error
                  </v-icon>
                  <template v-if="$store.state.app_display_scheme">
                    <SchemeIcon :scheme="item.request.scheme" />
                  </template>
                </div>
              </td>

              <td @click="showNotification(item)">
                <div style="display: flex; justify-content: center">
                  <v-chip
                    :color="item.notification_type.backgroundColor"
                    :text-color="getContrastingTextColor(item.notification_type.backgroundColor)"
                    >{{ item.notification_type.label }}</v-chip
                  >
                </div>
              </td>

              <td @click="showNotification(item)" style="padding: 8px 0">
                <b>{{ item.title }}</b>
                <br />{{ item.body }}
              </td>

              <td>
                <Loader small v-if="deletingNotification === item.id" />
                <v-btn v-else icon @click="deleteNotification(item)">
                  <v-icon> delete_outline </v-icon>
                </v-btn>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-row>
      <!-- FIN VISTA DESKTOP -->
    </template>
  </v-container>
</template>

<script>
import { SwipeList, SwipeOut } from "vue-swipe-actions";
import { mapState } from "vuex";
import "vue-swipe-actions/dist/vue-swipe-actions.css";
import { getContrastingTextColor } from "@/helpers/helpers";
import Loader from "./Loader.vue";
import SchemeIcon from "./SchemeIcon.vue";
import NotificationItem from "./NotificationItem.vue";

export default {
  name: "notification-list",

  components: {
    Loader,
    NotificationItem,
    SchemeIcon,
    SwipeOut,
    SwipeList,
  },

  data() {
    return {
      getContrastingTextColor,
      deletingNotification: null,
      headersNotifications: [
        { text: "", value: "request.id", sortable: false },
        {
          text: "Tipo de notificación",
          value: "notification_type.label",
          align: "center",
          sortable: false,
          groupable: false,
        },
        { text: "Detalle", value: "body", sortable: false, groupable: false },
        { text: "", value: "action", sortable: false, groupable: false },
      ],
    };
  },

  mounted() {
    this.getNotifications();
    this.$store.commit("set_app_title", "Notificaciones");
    window.scrollTo(0, 0);
  },

  methods: {
    deleteNotification(notification) {
      this.deletingNotification = notification.id;
      this.axios.delete(`notification/${notification.id}/`).then((_) => {
        this.getNotifications();
        this.deletingNotification = null;
      });
    },

    showNotification(notification) {
      this.markNotificationAsRead(notification);

      if (!this.mobsUser && notification.action == "chat") {
        const mediaQuery = window.matchMedia("(min-width: 960px)");
        if (!notification.request.id) {
          notification.request = { id: notification.request };
        }
        if (mediaQuery.matches) {
          this.$router.push({
            name: "request-detail",
            params: { id: notification.request.id },
          });
        } else {
          this.$router.push({
            name: "chat-detail",
            query: { requestId: notification.request.id },
          });
        }
      } else {
        this.$router.push({
          name: "request-detail",
          params: { id: notification.request.id },
        });
      }
    },

    getNotifications() {
      this.$store.commit("refresh_notifications", true);
    },

    markNotificationAsRead(notification) {
      this.axios.put(`notification/${notification.id}/read/`).then((_) => {
        this.getNotifications();
      });
    },

    revealFirstRight() {
      this.$refs.list.revealRight(0);
    },

    revealFirstLeft() {
      this.$refs.list.revealLeft(0);
    },

    closeFirst() {
      this.$refs.list.closeActions(0);
    },

    closeAll() {
      this.$refs.list.closeActions();
    },

    remove(item) {
      this.mockSwipeList = this.mockSwipeList.filter((i) => i !== item);
    },
  },

  computed: {
    ...mapState([
      "mobsUser",
      "user_notifications",
      "loading_notifications",
      "notification_type",
      "notification_status",
    ]),

    userNotifications() {
      return this.user_notifications;
    },
  },

  watch: {
    userNotifications(val) {
      const notifications = val;

      if (this.notification_type) {
        notifications.filter(
          (notification) =>
            notification.notification_type.name === this.notification_type
        );
      }

      if (this.notification_status) {
        notifications.filter(
          (notification) => notification.read === this.notification_status
        );
      }
    },
  },
};
</script>

<style scoped>
.icons {
  width: auto;
}

@media (max-width: 959px) {
  .notifications-container {
    padding: 0 !important;
    /* background: #EEEEEE; */
  }
  .v-application--wrap {
    background: #eeeeee !important;
  }
}
.loader-container {
  height: 90vh;
  display: flex;
  align-items: center;
  justify-content: center;
}
.highlighted {
  background: #e3f2fd;
}

::v-deep .swipeout-content {
  position: relative;
  z-index: 2;
}

::v-deep .swipeout-right {
  transform: translateX(calc(100% + 2px));
}
</style>
